import styled from '@emotion/styled';
import { motion } from 'framer-motion';

export const Overlay = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(8px);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

export const PopupContainer = styled(motion.div)`
  position: relative;
  max-width: 700px;
  max-height: 85vh;
  width: 100%;
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
`;

export const PopupContent = styled.div`
  overflow-y: auto;
  max-height: calc(85vh - 80px);
`;

export const PopupImage = styled.img`
  width: 100%;
  height: auto;
  display: block;
`;

export const ButtonContainer = styled.div`
  padding: 20px;
  background: white;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  gap: 15px;
`;

export const ContactButton = styled.button<{ colors: any }>`
  background: ${props => props.colors.primary};
  color: white;
  border: none;
  border-radius: 6px;
  padding: 12px 32px;
  font-size: 1rem;
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  
  &:hover {
    background: ${props => props.colors.primaryHover};
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 15px;
  right: 15px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.95);
  border: 2px solid #2C2C2C;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  line-height: 1;
  color: #2C2C2C;
  transition: all 0.3s ease;
  z-index: 10;
  font-weight: 300;
  
  &:hover {
    background: #2C2C2C;
    color: white;
  }
`;

